<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-form-group :label="label">
          <b-input-group>
            <b-input-group-prepend>
              <!--<b-button variant="light" :disabled="true">-->
              <!--Show me-->
              <!--</b-button>-->
              <b-dropdown variant="light">
                <template
                  slot="button-content"
                >{{ (selected) ? selected.label : 'Select Day filter' }}
                </template>
                <template v-for="(option, key) in options">
                  <b-dropdown-header :key="key" v-if="option.header">{{ option.header }}</b-dropdown-header>
                  <b-dropdown-item :key="key" v-else @click="setSelected(option)">{{ option.label }}</b-dropdown-item>
                </template>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input-group-append :id="'DateRangeDropdown-' + id">
              <!--<b-button variant="light" :disabled="true">Bookings</b-button>-->
              <template v-if="isRange">
                <b-button variant="light" @click="showPopover = !showPopover">
                  {{ from | moment('D&nbsp;MMM&nbsp;YY') }}
                  - {{ to | moment('D&nbsp;MMM&nbsp;YY') }}
                </b-button>
                <b-button
                  variant="light"
                  @click="showPopover = !showPopover"
                >{{ (showPopover) ? 'Done' : 'Change' }}
                </b-button>
              </template>
              <template v-else>
                <b-button variant="light" @click="clearSelected" :disabled="notSelected">Clear</b-button>
              </template>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-popover :show.sync="showPopover" :target="'DateRangeDropdown-' + id">
      <b-btn @click="showPopover = !showPopover" class="close" aria-label="Close">
        <span class="d-inline-block" aria-hidden="true">&times;</span>
      </b-btn>
      <b-row>
        <b-col md="12" class="my-2">
          <v-input-date
            :value="from"
            startOf="day"
            label="From:"
            :disabled="disabled"
            @input="updateFrom($event)"
          ></v-input-date>
        </b-col>
        <b-col md="12" class="my-2">
          <v-input-date
            :value="to"
            endOf="day"
            label="To:"
            :disabled="disabled"
            @input="updateTo($event)"
            :min="this.from"
          ></v-input-date>
        </b-col>
        <b-col md="12" class="my-2 text-right">
          <b-button variant="light" @click="clearSelected" size="sm" :disabled="notSelected">Clear</b-button>
          <b-button @click="showPopover = !showPopover" size="sm" variant="primary">Done</b-button>
        </b-col>
      </b-row>
    </b-popover>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateRange',
  props: {
    label: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    let id = Math.floor(Math.random() * (1000 - 0 + 1)) + 0

    return {
      id: id,
      selected: null,
      options: [
        {
          header: 'Months'
        },
        {
          label: 'Last Month\'s',
          addBy: 'month',
          from: -1,
          to: -1
        },
        {
          label: 'This Month\'s',
          addBy: 'month',
          from: 0,
          to: 0
        },
        {
          label: 'Next Month\'s',
          addBy: 'month',
          from: 1,
          to: 1
        },
        {
          header: 'Weeks'
        },
        {
          label: 'Last Week\'s',
          addBy: 'week',
          from: -1,
          to: -1
        },
        {
          label: 'This Week\'s',
          addBy: 'week',
          from: 0,
          to: 0
        },
        {
          label: 'Next Week\'s',
          addBy: 'week',
          from: 1,
          to: 1
        },
        {
          header: 'Days'
        },
        {
          label: 'Yesterday\'s',
          addBy: 'day',
          from: -1,
          to: -1
        },
        {
          label: 'Today\'s',
          addBy: 'day',
          from: 0,
          to: 0
        },
        {
          label: 'Tomorrow\'s',
          addBy: 'day',
          from: 1,
          to: 1
        },
        {
          header: 'Custom'
        },
        {
          label: 'Range',
          from: null,
          to: null,
          range: true
        }
      ],
      showPopover: false
    }
  },
  computed: {
    notSelected () {
      return this.selected === null
    },
    isRange () {
      return !this.notSelected && this.selected.range
    }
  },
  methods: {
    setSelected (option) {
      this.selected = option || null
    },
    clearSelected () {
      this.selected = null
    },
    updateFrom (value) {
      this.$emit('inputFrom', value)
    },
    updateTo (value) {
      this.$emit('inputTo', value)
    }
  },
  watch: {
    from (newVal) {
      if (newVal) {
        // if (this.to && moment(newVal).isAfter(this.to)) {
        //   this.updateTo(newVal);
        // }
        this.selected = this.options[13]
        this.from = newVal
      }
    },
    isRange (newVal) {
      // this.showPopover = !!newVal;
    },
    selected (newVal) {
      moment.updateLocale('en', {
        week: {
          dow: 1
        }
      })
      if (!newVal) {
        this.updateFrom(null)
        this.updateTo(null)
      } else if (newVal.label != 'Range') {
        let mFrom = moment()
          .add(newVal.from, newVal.addBy)
          .startOf(newVal.addBy)
        let mTo = moment()
          .add(newVal.to, newVal.addBy)
          .endOf(newVal.addBy)
        this.updateFrom(mFrom.toISOString())
        this.updateTo(mTo.toISOString())
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/inputDateRange.vue